import { types } from 'mobx-state-tree';

const OrderSortOrderBy = {
  DATE_PURCHASED: 'DATE_PURCHASED',
  DELIVERY_DATE: 'DELIVERY_DATE',
  NUMBER_OF_PRODUCTS: 'NUMBER_OF_PRODUCTS',
  ORDERS_ID: 'ORDERS_ID',
  REFERENCE: 'REFERENCE',
  STATUS: 'STATUS',
  TOTAL: 'TOTAL',
};

export default OrderSortOrderBy;

export const OrderSortOrderByType = types.enumeration(
  'OrderSortOrderBy',
  Object.values(OrderSortOrderBy)
);
